module.exports = __webpack_public_path__ + "static/media/sprite.1371e919.svg";